import "../../../chunks/index-server.js";
import { a as store_get, b as escape_html, n as ensure_array_like, o as unsubscribe_stores } from "../../../chunks/server.js";
import "../../../chunks/index-server2.js";
import "../../../chunks/navigation.js";
import { t as shoppingList } from "../../../chunks/stores.js";
//#region src/routes/cart/+page.svelte
function _page($$renderer, $$props) {
	$$renderer.component(($$renderer) => {
		var $$store_subs;
		let total = 0;
		$$renderer.push(`<div class="flex justify-center items-center h-[calc(100vh-64px)]"><div class="flex flex-col gap-4 bg-white p-12 rounded-md"><ul><!--[-->`);
		const each_array = ensure_array_like(store_get($$store_subs ??= {}, "$shoppingList", shoppingList));
		for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
			let name = each_array[$$index];
			$$renderer.push(`<li class="border-gray-700 border p-4 bg-gray-300"><div class="flex gap-4"><span class="text-xl">Plot Id: ${escape_html(name.id)}</span> <div class="flex flex-col"><span class="text-xl">Price: ${escape_html(name.price)}€</span> <span class="text-xl">${escape_html(name.plantedTrees === true ? "Tree planting: 5.99€" : "No trees: 0€")}</span></div></div></li>`);
		}
		$$renderer.push(`<!--]--></ul> <span class="text-2xl">Total: ${escape_html(total)}€</span> <button class="bg-yellow-500 hover:bg-yellow-600 px-5 py-2 rounded-full cursor-pointer">Buy</button> <button class="bg-gray-400 hover:bg-gray-500 px-5 py-2 rounded-full cursor-pointer">Clear Cart</button></div></div>`);
		if ($$store_subs) unsubscribe_stores($$store_subs);
	});
}
//#endregion
export { _page as default };
